<template>
  <div 
    v-if="isVisible && id !== 0" 
    class="container fixed-bottom bottom-6 z-50 w-full"
  >
    <!-- Main Container -->
    <div class="flex items-center justify-between gap-4 rounded-md px-4 relative bg-white shadow-lg ">
      <!-- Image and Title Section -->
      <div class="image-title flex items-center gap-4 md:block hidden">
        <img :src="getImage(image)" alt="Audio Image" style="width: 30px; height: 30px; object-fit: cover;" />
        <div class="text-sm font-semibold text-gray-700 flex-grow">
          <p>{{ title }}</p>
        </div>
      </div>

      <!-- Audio Player Controls -->
      <div class="flex justify-center">
        <audio ref="audio" controls autoplay class="w-full">
          <source :src="link_url" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      
    <label for="speed">Speed : </label>
    <select id="speed" v-model="playbackRate" @change="changeSpeed(playbackRate)">
      <option :value="0.5">0.5x</option>
      <option :value="1" selected>1x (Normal)</option>
      <option :value="1.5">1.5x</option>
      <option :value="2">2x</option>
      <option :value="2.5">2.5x</option>
      <option :value="3">3x</option>
    </select>
      </div>

      <!-- Close Button -->
      <button 
        @click="closePlayer" 
        class="text-gray-500 hover:text-gray-800 focus:outline-none"
        aria-label="Close">
        <span class="text-xl">✖</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';

// Props passed from parent component
const props = defineProps({
  id: Number,
  title: String,
  image: String,
  link_url: String,
});

// State management
const isVisible = ref(true);
const audio = ref(null); 
const playbackRate = ref(1);

function changeSpeed(playback) {
  audio.value.playbackRate = playback;
}

// Play the audio function
const playAudio = (url) => {

  if (audio.value) {
    audio.value.pause(); // Stop current playback
    audio.value.src = url; // Set the new source
    
    audio.value
      .play()
      .then(() => {
        console.log('Audio is playing:', url);
      })
      .catch((err) => {
        console.warn('Autoplay blocked, waiting for user interaction:', err.message);
      });
  }
};

// Watch `link_url` for changes
watch(
  () => props.link_url,
  (newLinkUrl) => {
    if (newLinkUrl) {
      isVisible.value = true;
      playAudio(newLinkUrl);
    }
  },
  { immediate: true }
);

// Close the audio player
const closePlayer = () => {
  isVisible.value = false;
  if (audio.value) {
    audio.value.pause();
    audio.value.src = '';
  }
};

// On mounted
onMounted(() => {
  if (props.link_url) {
    playAudio(props.link_url);
  }
});

// On unmounted
onUnmounted(() => {
  if (audio.value) {
    audio.value.pause();
    audio.value.src = '';
  }
});
</script>

<style scoped>
/* Styling for the fixed audio player */
.fixed-bottom {
  position: fixed;
  bottom: 5rem;
  left: 0;
  right: 0;
  z-index: 50;
}
.bg-white {
  background-color: white;
}
.shadow-lg {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
button {
  flex-shrink: 0;
}

/* Hide the player on mobile screens */
@media (max-width: 767px) {
  .image-title {
    display: none;
  }
}
</style>
